import { UserRoleType } from 'app/models';

import { PermissionFunctionality } from './userActions';

export const HIDDEN_EDIT_FUNCTIONALITY_KEYS: PermissionFunctionality[] = [
  PermissionFunctionality.MAPS,
  PermissionFunctionality.TERRITORY_DEFINITION_AND_ASSIGNMENT
];

export const getRestrictedEditFunctionalityKeys = (
  isAddedConfigurationsForUserPermissionsEnabled: boolean,
  selectedRole: UserRoleType
) => {
  if (!isAddedConfigurationsForUserPermissionsEnabled) {
    return HIDDEN_EDIT_FUNCTIONALITY_KEYS;
  }

  if (selectedRole === (UserRoleType.BATTLE_CARD_OWNER as UserRoleType)) {
    return [PermissionFunctionality.MAPS];
  }

  return [PermissionFunctionality.MAPS, PermissionFunctionality.TERRITORY_DEFINITION_AND_ASSIGNMENT];
};
